// extracted by mini-css-extract-plugin
module.exports = {"footer":"ReorderModal_footer__2gnyK","subheader":"ReorderModal_subheader__F2dPs","listWrap":"ReorderModal_listWrap__3bk6W"};